// RangeChart.js
import React from 'react';
import { Column } from '@ant-design/plots';

const RangeChart = () => {
  // Define the data for the range chart
  const data = [
    { category: 'Carbohydrate', start: 0, end: 8000 },
    { category: 'Methane', start: 8000, end: 12000 },
    { category: 'Nitrous Oxide', start: 12000, end: 19000 },
    { category: 'Unknown', start: 19000, end: 21000 },
    { category: 'Total', start: 0, end: 21000 },
  ];

  // Configuration for the range chart
  const config = {
    data,
    theme: "classicDark",
    height: 200,
    xField: 'category',
    yField: ['start', 'end'],
    colorField: (d) => (d.category === 'Total' ? 'Total' : 'Green'), // Use green for other categories
    tooltip: {
      items: ['start', 'end'],
    },
    meta: {
      category: {
        alias: 'Category',
      },
      start: {
        alias: 'Start Value',
      },
      end: {
        alias: 'End Value',
      },
    },
    color: ['Green', 'Blue'], // Define colors for the categories
    axis: {
      y: { labelFormatter: '~s' },
    },
  };

  return <Column {...config} />;
};

export default RangeChart;
